import React from 'react'
import AppChip, { APP_CHIP_BASE_SX, buildAppChipSx } from '../../components/chips/AppChip'
import { RBAC_ROLE_CHIP_COLORS, RBAC_STATUS_COLORS } from './constants/rbacChipColors'

export const rbacStatusChipSx = APP_CHIP_BASE_SX

export const rbacActiveChipSx = buildAppChipSx({
  backgroundColor: RBAC_STATUS_COLORS.active.background,
  color: RBAC_STATUS_COLORS.active.text
})

export const rbacInactiveChipSx = buildAppChipSx({
  backgroundColor: RBAC_STATUS_COLORS.inactive.background,
  color: RBAC_STATUS_COLORS.inactive.text
})

export const rbacPendingChipSx = buildAppChipSx({
  backgroundColor: RBAC_STATUS_COLORS.pending.background,
  color: RBAC_STATUS_COLORS.pending.text
})

export const rbacRoleChipSx = buildAppChipSx({
  backgroundColor: RBAC_ROLE_CHIP_COLORS.assigned.background,
  color: RBAC_ROLE_CHIP_COLORS.assigned.text
})

export const rbacUnassignedRoleChipSx = buildAppChipSx({
  backgroundColor: RBAC_ROLE_CHIP_COLORS.unassigned.background,
  color: RBAC_ROLE_CHIP_COLORS.unassigned.text
})

export function getRbacStatusChipSx(status) {
  if (status === 'ACTIVO') return rbacActiveChipSx
  if (status === 'INACTIVO') return rbacInactiveChipSx
  if (status === 'PENDIENTE') return rbacPendingChipSx
  return rbacStatusChipSx
}

export function RbacStatusChip({ label, size = 'small', sx = {} }) {
  return (
    <AppChip
      label={label}
      size={size}
      sx={{ ...getRbacStatusChipSx(label), ...sx }}
    />
  )
}

export function RbacRoleChip({ label, unassigned = false, sx = {} }) {
  return (
    <AppChip
      label={label}
      renderAs="span"
      sx={{ ...(unassigned ? rbacUnassignedRoleChipSx : rbacRoleChipSx), ...sx }}
    />
  )
}
